export default __webpack_public_path__ + "static/media/hotandspicy.aefa071f.jpg";